import { useState, useEffect } from 'react';
import { IoClose } from "react-icons/io5";

export default function InStationZoneModal({ isOpen, onClose, onSubmit, editData, zones = [] }) {
  const [formData, setFormData] = useState({
    zoneId: '',
    minDistance: '',
    maxDistance: '',
    multiplier: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        zoneId: '',
        minDistance: '',
        maxDistance: '',
        multiplier: ''
      });
      setErrors({});
    } else if (editData) {
      setFormData({
        zoneId: editData.zone_name || '',
        minDistance: editData.min_distance || '',
        maxDistance: editData.max_distance || '',
        multiplier: editData.multiplier || ''
      });
      setErrors({});
    }
  }, [isOpen, editData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'zoneId') {
      setFormData(prev => ({ ...prev, [name]: value }));
    } else {
      const regex = /^\d*\.?\d*$/;
      if (regex.test(value) || value === '') {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
    }

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.zoneId) {
      newErrors.zoneId = 'Zone name is required';
    }

    if (!formData.minDistance) {
      newErrors.minDistance = 'Minimum Distance is required';
    }

    if (!formData.maxDistance) {
      newErrors.maxDistance = 'Maximum Distance is required';
    }

    if (formData.minDistance && formData.maxDistance) {
      const min = parseFloat(formData.minDistance);
      const max = parseFloat(formData.maxDistance);
      if (min >= max) {
        newErrors.maxDistance = 'Maximum Distance must be greater than Minimum Distance';
      }
    }

    if (!formData.multiplier) {
      newErrors.multiplier = 'Zone Multiplier is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const submitData = {
        zone_name: formData.zoneId,
        min_distance: parseFloat(formData.minDistance),
        max_distance: parseFloat(formData.maxDistance),
        multiplier: parseFloat(formData.multiplier)
      };
      onSubmit(submitData);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-800">
            {editData ? "Edit In-Station Zone" : "Add In-Station Zone"}
          </h2>
          <button
            className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            onClick={onClose}
          >
            <IoClose className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                In Station Zone Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="zoneId"
                value={formData.zoneId}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.zoneId ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="Enter in station zone name"
              />
              {errors.zoneId && (
                <p className="text-red-500 text-sm mt-1">{errors.zoneId}</p>
              )}
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">
                In Station Zone Multiplier <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="multiplier"
                value={formData.multiplier}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.multiplier ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.multiplier && (
                <p className="text-red-500 text-sm mt-1">{errors.multiplier}</p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                In Station Minimum Distance <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="minDistance"
                value={formData.minDistance}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.minDistance ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.minDistance && (
                <p className="text-red-500 text-sm mt-1">{errors.minDistance}</p>
              )}
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">
                In Station Maximum Distance <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="maxDistance"
                value={formData.maxDistance}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.maxDistance ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.maxDistance && (
                <p className="text-red-500 text-sm mt-1">{errors.maxDistance}</p>
              )}
            </div>
          </div>


          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-reset-filter justify-center"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn justify-center ${
                editData ? "btn-edit text-white" : "btn-primary"
              }`}
            >
              {editData ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}